import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Wazuh extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M17.721,0,14.773,6.2h-5.4L6.147,0,3.9,7.878.811,11.4,7.758,17.77l2.7,6.23h3.089L16.1,17.877l7.088-6.421L20.034,7.987ZM14.263,16.633a.645.645,0,0,1-.265.223.9.9,0,0,1-.35.072.868.868,0,0,1-.34-.072.638.638,0,0,1-.259-.224l-1.042-1.578-1.05,1.578a.655.655,0,0,1-.26.224.9.9,0,0,1-.343.072.7.7,0,0,1-.618-.3l-5.35-4.98H5.878L10.384,15.6l.895-1.412h1.432l.975,1.412,4.578-4.121h1.355Z" />
      </svg>
    );
  }
}

export default Wazuh;
